export interface HeaderBarType {
  className?: string
  title: string
}

const HeaderBar = ({ className, title }: HeaderBarType) => (
  <div
    className={`bg-sale-analytic w-full py-[20px] flex justify-center ${className} rounded-[8px] bg-cover`}
  >
    <div className='text-[24px] font-mitr text-white'>{title}</div>
  </div>
)

export default HeaderBar
